function omitDeepKey(value, key) {
    if (Array.isArray(value)) {
        return value.map((i) => omitDeepKey(i, key));
    }
    if (
        typeof value === "object" &&
        value !== null &&
        value instanceof Date === false
    ) {
        return Object.keys(value).reduce((newObject, k) => {
            if (k === key) return newObject;
            return Object.assign(
                { [k]: omitDeepKey(value[k], key) },
                newObject,
            );
        }, {});
    }
    return value;
}

export default function omitDeep(value, keys) {
    return keys.reduce((acc, key) => omitDeepKey(acc, key), value);
}
